import formAdminOrganizations from './formAdminOrganizations';
import tableAdminOrganizations from './tableAdminOrganizations';
import tableAppCategories from './tableAppCategories';


export default {
  title: 'Admin Organization',
  noArea:true,
  attributeName: 'organization',
  getURL: 'organization',
  createURL: 'organization',
  updateURL: 'organization',
  removeURL: 'organization',
  removeReconfirmMessage:'Are you sure you want to delete this Organization?',
  removeReconfirmURL:'organization/deleteConfirm',
  sessionParams: [],
  // formConfig: [
  //   formAdminOrganizations,
  // ],
  tableConfig: tableAdminOrganizations,
  autoUpdate: true,
};
